"use client";

import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import styles from "../pages/auth/css/register.module.css";

const PasswordInput = ({ value, onChange, isValid }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={styles.formGroup}>
      <label>Password</label>
      <div className={styles.passwordInputContainer}>
        <input
          type={showPassword ? "text" : "password"}
          name="password"
          value={value}
          onChange={onChange}
          className={`${styles.formInput} ${
            value ? (isValid ? styles.validPassword : styles.invalidPassword) : ""
          }`}
          required
        />
        <button
          type="button"
          className={styles.passwordToggleBtn}
          onClick={() => setShowPassword(!showPassword)}
          tabIndex="-1"
        >
          {showPassword ? (
            <EyeOff className={styles.passwordEyeIcon} size={18} />
          ) : (
            <Eye className={styles.passwordEyeIcon} size={18} />
          )}
        </button>
      </div>
      <small>
        8+ chars with lowercase, uppercase, number &amp; special char
      </small>
    </div>
  );
};

export default PasswordInput;
